<div class="informationMessage">
  <span>
    {{ changesInformationMessage }}
  </span>
  <div>
    <mat-checkbox class="example-margin"
                  [checked]="allMenusChecked"
                  (change)="setAllMenusChecked($event.checked)">
      {{ 'MENU.SELECT_ALL' | translate }}
    </mat-checkbox>
  </div>
  <div *ngFor="let menuSection of menuSections">
    <mat-checkbox matInput
                  [checked]="selectedMenuSections[menuSection.id]"
                  [disabled]="menuSection.id === currentMenuSectionId"
                  (change)="menuSelected(menuSection.id)">
      <label>{{ menuSection.name }}</label>
    </mat-checkbox>
  </div>
</div>
